/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {Component, OnInit} from '@angular/core';
import {FabMessageService} from '@fabric/components/message';
import {
  ColDef,
  RowSelectionOptions,
  SizeColumnsToContentStrategy,
  SizeColumnsToFitGridStrategy,
  SizeColumnsToFitProvidedWidthStrategy
} from 'ag-grid-community';
import {DISMISS_MSG} from '../../../common/constants';
import {StateService} from '../../../core/state/state.service';
import {User} from '../../../models/user.model';
import {VehicleScenario} from '../../../models/vehicle-scenario-dto.model';
import {VehicleScenarioService} from '../../../services/vehicle-scenario.service';

@Component({
    selector: 'app-vehicle-duplicate-check',
    templateUrl: './vehicle-duplicate-check.component.html',
    styleUrls: ['./vehicle-duplicate-check.component.scss'],
    standalone: false
})
export class VehicleDuplicateCheckComponent implements OnInit {
  user: User;

  showSpinner: boolean;
  showTable: boolean;

  vehScenWithDupes: VehicleScenario[];
  selectedRow: any;

  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
    type: "fitGridWidth",
  };
  rowSelection: RowSelectionOptions = {
    mode: 'singleRow',
    checkboxes: false,
    enableClickSelection: true,
    enableSelectionWithoutKeys: true,
  };
  vehScenColumns: ColDef[] = [
    {field: 'vehScenId', headerName: 'VEHICLE SCENARIO ID'},
    {field: 'vehScenName', headerName: 'NAME'},
    {field: 'fcorg', headerName: 'FCORG'}
  ];

  constructor(public snackBar: FabMessageService,
              private readonly stateService: StateService,
              private readonly vehicleScenarioService: VehicleScenarioService) {
  }

  ngOnInit(): void {
    this.user = this.stateService.user;
    this.selectedRow = null;
    this.showTable = false;
    this.getVehScenListForDupeCheck();
  }

  /**
   * Get list of Vehicle Scenarios that contain Duplicate records
   */
  getVehScenListForDupeCheck(): void {
    this.showSpinner = true;
    this.vehicleScenarioService.getVehScenListForDupeCheck().subscribe(data => {
      this.vehScenWithDupes = data;
    }, err => {
      this.snackBar.displayError(err, DISMISS_MSG);
      this.showSpinner = false;
    }, () => {
      this.showSpinner = false;
    });
  }

  /**
   * Scan all Vehicle Scenarios for any duplicate records
   */
  scanVehScenDupes(): void {
    this.showSpinner = true;
    this.vehicleScenarioService.scanForVehScenDupes(this.user.gmid).subscribe(() => {
    }, err => {
      this.snackBar.displayError(err, DISMISS_MSG);
      this.showSpinner = false;
    }, () => {
      this.getVehScenListForDupeCheck();
    });
  }

  /**
   * Perform clean up on Vehicle Scenarios that contain duplicate records
   */
  removeDupes(): void {
    this.showSpinner = true;
    this.vehicleScenarioService.removeVehScenDupes(this.user.gmid, this.selectedRow.vehScenId).subscribe({
      error: err => {
        this.snackBar.displayError(err, DISMISS_MSG);
        this.showSpinner = false;
      },
      complete: () => {
        this.getVehScenListForDupeCheck();
      }
    });
  }

  /**
   * Event for selecting a scenario
   * @param event the event object
   */
  onSelect(event) {
    if (event.node.selected) {
      this.selectedRow = (event.data);
    } else if (event.data === this.selectedRow) {
      this.selectedRow = null;
    }
  }
}
